import React from 'react';
import PartnersPageLayout from '../components/PartnersPage/PartnersPageLayout';

const Partners: React.FC = () => <PartnersPageLayout />;

export default Partners;
